import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import SingleStar from './single-star';

const Wrapper = styled.div`
    align-self: flex-end;
    @media (max-width: 767px) {
        align-self: flex-start;
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 4px;

    @media (max-width: 767px) {
        margin-left: -4px;
        margin-top: 8px;
    }
`;

const StarContainer = styled.div`
    margin: 0 4px;
    svg {
        fill: var(--blue500);
    }
`;

const RatingStars = ({ onChange = () => {}, totalStars = 5, disabled = false }) => {
    const [starSelected, setStarSelected] = useState(0);
    const [starHover, setStarHover] = useState(0);

    const handleClick = (index) => {
        if (starSelected === index) {
            onChange(0);
            return setStarSelected(0);
        }
        onChange(index);
        return setStarSelected(index);
    };

    return (
        <Wrapper>
            <Container
                onMouseLeave={() => {
                    setStarHover(0);
                }}
            >
                {[...Array(totalStars)].map((n, index) => {
                    return (
                        <StarContainer key={index}>
                            <SingleStar
                                disabled={disabled}
                                setStarHover={setStarHover}
                                hover={starHover}
                                number={index}
                                selected={starSelected}
                                onClick={() => handleClick(index + 1)}
                                className="single-star"
                            />
                        </StarContainer>
                    );
                })}
            </Container>
        </Wrapper>
    );
};

RatingStars.propTypes = {
    onChange: PropTypes.func,
    /** Definisce il numero totale di stelle. */
    totalStars: PropTypes.number,
    disabled: PropTypes.bool,
};
export default RatingStars;
